export function determineActiveIndex(pathname = "") {
  const path = pathname.toLowerCase();

  if (path.startsWith("/accounts") || path.startsWith("/account")) return 2;
  if (path.startsWith("/trades")) return 17;
  if (path.startsWith("/transactions")) return 3;
  if (path.startsWith("/sales-participation")) return 18;
  if (path.startsWith("/challenges")) return 4;
  if (path.startsWith("/dollar")) return 19;
  if (path.startsWith("/customers")) return 5;
  if (path.startsWith("/kyc")) return 6;
  if (path.startsWith("/support")) return 7;
  if (path.startsWith("/coupons")) return 8;
  if (path.startsWith("/announcements")) return 11;
  if (path.startsWith("/rules")) return 12;
  if (path.startsWith("/blogs")) return 13;
  if (path.startsWith("/profile")) return 14;
  if (path.startsWith("/admins")) return 15;
  if (path.startsWith("/logs")) return 16;

  return 1;
}

const miniAsidePathPatterns = [];

export function shouldUseMiniAside(pathname = "") {
  const path = pathname.toLowerCase();
  return miniAsidePathPatterns.some((pattern) => pattern.test(path));
}
